import styled from 'styled-components';
import { Color } from '../../config/Color';

export const HighlightLink = styled.a`
  color: ${Color.content.accent};
  &:hover {
    color: ${Color.content.accent};
  }
`;
